function getSpeakerLocationPOIQuery(speaker) {
  // return `${speaker.address ? speaker.address.split(' ').join('+'): ''}+${speaker.address2 ? speaker.address2.split(' ').join('+'):''}+${speaker.city? speaker.city.split(' ').join('+'):''}+${speaker.state}+${speaker.zipcode}`
  return `${speaker.address ? speaker.address: ''}+${speaker.address2 ? speaker.address2:''}+${speaker.city? speaker.city:''}+${speaker.state}+${speaker.zipcode}`
}
// export default getSpeakerLocationPOIQuery
export default getSpeakerLocationPOIQuery
